import { z } from "zod";
import type {
  CreateColourGroupInput,
  UpdateColourGroupInput,
  ColourGroupFilters,
} from "@/types/business/colour-groups";

// Base colour group schema
export const colourGroupSchema = z.object({
  id: z.string().min(1, "ID is required"),
  name: z
    .string()
    .min(1, "Colour group name is required")
    .max(100, "Colour group name must be less than 100 characters")
    .regex(
      /^[a-zA-Z0-9\s\-_]+$/,
      "Colour group name can only contain letters, numbers, spaces, hyphens, and underscores"
    ),
  created: z.date(),
  updated: z.date(),
});

// Create colour group schema
export const createColourGroupSchema = z.object({
  name: z
    .string()
    .min(1, "Colour group name is required")
    .max(100, "Colour group name must be less than 100 characters")
    .regex(
      /^[a-zA-Z0-9\s\-_]+$/,
      "Colour group name can only contain letters, numbers, spaces, hyphens, and underscores"
    ),
}) satisfies z.ZodType<CreateColourGroupInput>;

// Update colour group schema
export const updateColourGroupSchema = z.object({
  id: z.string().min(1, "ID is required"),
  name: z
    .string()
    .min(1, "Colour group name is required")
    .max(100, "Colour group name must be less than 100 characters")
    .regex(
      /^[a-zA-Z0-9\s\-_]+$/,
      "Colour group name can only contain letters, numbers, spaces, hyphens, and underscores"
    )
    .optional(),
}) satisfies z.ZodType<UpdateColourGroupInput>;

// Filters schema
export const colourGroupFiltersSchema = z.object({
  search: z.string().optional(),
  hasColours: z.boolean().optional(),
  isEmpty: z.boolean().optional(),
}) satisfies z.ZodType<ColourGroupFilters>;

// Bulk operations schemas
export const deleteColourGroupsSchema = z.object({
  ids: z.array(z.string().min(1, "ID is required")),
});

export const duplicateColourGroupSchema = z.object({
  id: z.string().min(1, "ID is required"),
  newName: z
    .string()
    .min(1, "New name is required")
    .max(100, "Name must be less than 100 characters")
    .optional(),
});

export function validateNameUniqueness(
  name: string,
  existingNames: string[]
): boolean {
  return !existingNames
    .map((n) => n.toLowerCase())
    .includes(name.toLowerCase());
}
